import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { getCurrentProduct } from 'src/helpers/ReleaseNotesRoutingHelper';
import { getReleaseNotesPath } from 'src/helpers/RoutesHelper';
import { ReleaseNotesProduct } from 'src/types/release-notes/ReleaseNotesProduct';

interface UseReleaseNotesRoutingProps {
	topLevelProducts: ReleaseNotesProduct[];
	productSlug?: string;
	subProductSlug?: string;
}

export const useReleaseNotesRouting = ({
	topLevelProducts,
	productSlug,
	subProductSlug
}: UseReleaseNotesRoutingProps): ReleaseNotesProduct | null => {
	const history = useHistory();
	const currentProduct = getCurrentProduct(topLevelProducts, productSlug, subProductSlug);

	// Auto-navigate to first valid product if none selected
	useEffect(() => {
		// Need at least one product with defined structure to auto-navigate
		if (topLevelProducts.length < 1) {
			return;
		}

		const firstProduct = topLevelProducts[0];
		if (!firstProduct) {
			return;
		}

		const getFirstValidPath = (): string => {
			if (firstProduct.sub_products?.length > 0) {
				const firstSubProduct = firstProduct.sub_products[0];
				return getReleaseNotesPath(firstProduct.slug, firstSubProduct.slug);
			}
			return getReleaseNotesPath(firstProduct.slug);
		};

		if (!currentProduct) {
			history.replace(getFirstValidPath());
		}
	}, [currentProduct, topLevelProducts, history]);

	return currentProduct;
};
